import React, { useState, useRef, useEffect } from "react";
import "./CommonsStyles.css";
import { useSelector, useDispatch } from "react-redux";
import { imageLoader } from "../../utils/imageLoader";
import { useNavigate } from "react-router-dom";
import "./UserProfile.css";
import { logout } from "../../redux/actions/userAuthActions";
import EditCollaboratorModal from "../../views/backOffice/components/EditCollaboratorModal";
import { openModal } from "../../redux/actions/modalActions";
import { getUsersList } from "../../redux/actions/usersListAction";

const UserProfile = () => {
  const currentUser = useSelector((state) => state.userAuthReducer.user);
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getUsersList());
  }, [dispatch]);


  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleProfile = () => {
    setIsOpen(false);
    dispatch(
      openModal({
        title: currentUser?.profile,
        content: <EditCollaboratorModal documentId={currentUser.documentId} />,
      })
    );
  };

  const handleDisconnect = async () => {
    setIsOpen(false);
    dispatch(logout(navigate));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="user-profile-container" ref={modalRef}>
      <button className="honorairesBtn" onClick={toggleModal}>
        <img src={imageLoader(currentUser?.profile_image?.url)} alt="photo de profile" className="profileImg" style={{ objectFit: "contain" }} />
      </button>

      {isOpen && (
        <div className="user-profile-modal">
          <div className="modal-option" onClick={handleProfile}>
            <span className="f18 darkGrey medium">Profil</span>
          </div>
          <div className="modal-option" onClick={handleDisconnect}>
            <span className="f18 darkGrey medium">Déconnexion</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
